import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62b88952"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-bg-[#FEE5E2] tw-px-[12px] tw-py-[8px] tw-flex tw-items-center tw-mt-[37px] tw-rounded-[6px] tw-gap-[10px]"
}
const _hoisted_2 = { class: "tw-text-[#F7553C] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-start tw-mb-[0px]" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "tw-mb-[25px] tw-pt-[12px] tw-leading-[100%]" }
const _hoisted_5 = { class: "tw-text-[#231F20] tw-text-[14px] tw-font-medium" }

import { ensurePeriod, getComponentUiText } from "@/utils/utilities";
import WizardQuestion from "./wizardQuestion.vue";
import WizardRadioQuestion from "./wizardRadioQuestion.vue";
import { Ref, computed, onMounted, ref, watch } from "vue";

import ButtonAddAnother from "./buttonAddAnother.vue";
import store from "@/store";
import cloneDeep from "lodash/cloneDeep";
import { PropType } from "vue";
import ListWebFacing from "./listWebFacing.vue";
import { useRoute } from "vue-router";
import { WIZARD_STATE_NAME, statusPage } from "@/utils/constants";
import dayjs from "dayjs";
import WarningIcon from "../svgs/warningIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'webFacinggAppPage',
  props: {
  listWebFacing: {
    type: Array as PropType<any[]>,
    default: () => [],
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
      errorMessage: "",
    }),
  },
},
  emits: [
  "onUpdate",
  "update:answer",
  "update:toggleValue",
  "update:listWebFacing",
  "changeDataWebFacing",
],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;


const listWebFacingRef: any = ref([]);

let typeIdSelectedDropdown = "";

const formData: Ref<any> = ref([
  {
    showAccordion: false,
    typeId: "",
    url: "",
    name: "",
    isWebsite: 3,
    isArchived: false,
  },
]);

const isDisabledChecked = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (setupWizard.valuesWebservies) {
    const isDisabledChecked = setupWizard.valuesWebservies.some(
      (item) => (item.name || item.typeId || item.url) && !item.isArchived,
    );
    return isDisabledChecked ? 1 : false;
  } else {
    return false;
  }
});

const valuesWebservies = computed(() => {
  return store.state.SetupWizard.valuesWebservies;
});

const isServiceName = computed(() => {
  const queryValue = route.query?.type;
  const appName =
    isShowDetail.value === null
      ? formData.value.some(
          (item) => (item.name || item.typeId || item.url) && !item.isArchived,
        )
      : isShowDetail.value;
  return appName || queryValue === WIZARD_STATE_NAME.WEBSERVICES ? 1 : "";
});

watch(props.statusInPage, (value) => {
  if (
    (value.statusPage === statusPage.CallApi ||
      value.statusPage === statusPage.Error) &&
    (props.statusInPage.dataError.length > 1 ||
      (props.statusInPage.dataError.length === 1 &&
        !props.statusInPage.dataError[0].endDate))
  ) {
    formData.value = formData.value.map((item) => {
      item.isCallAPI = true;
      return item;
    });
  }
});

watch(valuesWebservies, (value) => {
  if (value.length === 0) {
    formData.value = [
      {
        showAccordion: false,
        typeId: "",
        url: "",
        name: "",
        isWebsite: 3,
        isArchived: false,
      },
    ];
    return;
  }
  initFormData();
});

watch(
  props.listWebFacing,
  () => {
    formData.value = props.listWebFacing;
  },
  { deep: true },
);

watch(
  formData,
  (newValue, oldValue) => {
    newValue.forEach((item) => {
      if (item.typeId && item.serviceTypeId === "web-nat") {
        item.isStatus = 0;
      } else if (item.typeId && item.serviceTypeId === "web") {
        item.isStatus = 1;
      }
    });
    return emits("update:listWebFacing", newValue);
  },
  { deep: true },
);

const handleDataWebFacingPage = (item) => {
  formData.value[item.index] = item.data;
  emits("changeDataWebFacing", true);
};


const updateStore = (itemIds) => {
  typeIdSelectedDropdown = itemIds;
  emits("changeDataWebFacing", true);
};
const isShowDetail = ref(null);

const currentOrg = computed(() => store.state.Org.currentOrg);
const route = useRoute();

onMounted(() => {
  const queryValue = route.query?.type;
  if (valuesWebservies.value.length === 0) {
    formData.value = [
      {
        showAccordion: queryValue === WIZARD_STATE_NAME.WEBSERVICES,
        typeId: "",
        url: "",
        name: "",
        isWebsite: 3,
        isArchived: false,
        isStatus: "",
      },
    ];
    if (queryValue === WIZARD_STATE_NAME.WEBSERVICES) {
      checkYesNo(1);
      setTimeout(() => {
        document
          .getElementById(`input-webfacing-${formData.value.length - 1}`)
          ?.focus();
      }, 1000);
    }
    return;
  } else {
    initFormData();
    if (queryValue === WIZARD_STATE_NAME.WEBSERVICES) {
      addAnother(true);
      setTimeout(() => {
        document
          .getElementById(`input-webfacing-${formData.value.length - 1}`)
          ?.focus();
      }, 2000);
    }
  }
});

const initFormData = () => {
  const data = cloneDeep(valuesWebservies.value);
  data.map((item) => {
    item.name = item.description || item.appName;
    item.timeUpdated = dayjs();
    item.isStatus = item.serviceTypeId === "web-nat" ? 0 : 1;
    return item;
  });
  if (valuesWebservies.value.length > 0) {
    formData.value = cloneDeep(data);
    return;
  }
  formData.value = {
    ...cloneDeep(data),
    ...cloneDeep(formData.value),
  };
};

const checkYesNo = (value) => {
  if (value === 1) {
    isShowDetail.value = true;
  } else {
    isShowDetail.value = false;
  }
  emits("onUpdate", value);
};

const addAnother = (isShowAccordion = false) => {
  const objAdd = ref({
    showAccordion: isShowAccordion,
    typeId: "",
    name: "",
    url: "",
    isWebsite: 3,
    isArchived: false,
    isStatus: "",
    isCallAPI: false,
  });

  formData.value.push(objAdd.value);
};

const checkAllValidations = async () => {
  let isAllValid = true,
    listServices = [] as any[];
  for (let index = 0; index < listWebFacingRef.value.length; index++) {
    const test = await listWebFacingRef.value[index].saveChanges();
    if (!test.isValid) {
      isAllValid = false;
    }
    listServices.push(test.finalValue);
  }
  return isAllValid;
};

const onDeleteItem = (index) => {
  formData.value.splice(index, 1);
};

__expose({
  checkAllValidations,
  onDeleteItem,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(WizardQuestion, {
      title: 
        _unref(getComponentUiText)(
          'app-menu-submenu-home-setup-wizard-web-facing-app-title-1',
        )
      ,
      description: 
        _unref(getComponentUiText)(
          'app-menu-submenu-home-setup-wizard-web-facing-app-description-1',
        )
      
    }, {
      default: _withCtx(() => [
        _createVNode(WizardRadioQuestion, {
          class: _normalizeClass(['tw-mb-[25px]']),
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-web-facing-app-title-question-1',
          )
        ,
          answer: isServiceName.value,
          required: true,
          disabled: isDisabledChecked.value,
          onOnUpdate: checkYesNo
        }, null, 8, ["title", "answer", "disabled"]),
        (
          __props.statusInPage.statusPage === _unref(statusPage).Error &&
          __props.statusInPage.errorMessage
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(WarningIcon, { color: "#F7553C" }),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(getComponentUiText)(
              "app-component-wizards-setup-error-tooltip",
              false,
              {
                errorMessage: __props.statusInPage.errorMessage
                  ? _unref(ensurePeriod)(__props.statusInPage.errorMessage)
                  : "",
              },
            )), 1)
            ]))
          : _createCommentVNode("", true),
        (isShowDetail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
              "app-menu-submenu-home-setup-wizard-web-facing-app-title-2",
            )), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${item.timeUpdated}-${index}`,
                  class: "tw-mb-[10px]"
                }, [
                  _createVNode(ListWebFacing, {
                    ref_for: true,
                    ref_key: "listWebFacingRef",
                    ref: listWebFacingRef,
                    data: { item: item, index: index },
                    "status-in-page": __props.statusInPage,
                    "onUpdate:value:store": handleDataWebFacingPage
                  }, null, 8, ["data", "status-in-page"])
                ]))
              }), 128)),
              _createVNode(ButtonAddAnother, { onClick: addAnother }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-menu-submenu-home-setup-wizard-web-facing-add-another-button-1",
            )), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "description"])
  ]))
}
}

})